// React / Next
import { motion, Variants } from 'framer-motion';

// Medium density SVG container variants (~22 paths)
const mediumSvgContainerVariants: Variants = {
  initial: { opacity: 1 },
  rest: {
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.01,
      staggerDirection: -1,
    },
  },
  hover: {
    transition: {
      staggerChildren: 0.01,
      staggerDirection: 1,
    },
  },
};

// Path animation variants (vertical slide)
const svgPathVariants: Variants = {
  initial: { y: 280, opacity: 0 },
  rest: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.34, 1.56, 0.64, 1],
    },
  },
  hover: {
    y: 280,
    opacity: 0,
    transition: { duration: 0.3, ease: 'easeIn' },
  },
};

/**
 * COOsGraphic - Converging lines pattern with orange and cyan
 * Medium path density with moderate stagger timing
 */
export const COOsGraphic = () => (
  <motion.svg
    viewBox="0 0 146 262"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-auto h-full block"
    variants={mediumSvgContainerVariants}
    aria-hidden="true"
  >
    <motion.g>
      <motion.path
        variants={svgPathVariants}
        d="M3.11995 187.598H2.3371L0.000244141 0H5.4568L3.11995 187.598Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M17.1176 0L14.8626 187.598H14.0914L11.8948 0H17.1176Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M28.7785 0L26.6169 187.598H25.8458L23.801 0H28.7785Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M40.4396 0L38.3715 187.598H37.6003L35.6958 0H40.4396Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M52.1003 0L50.1256 187.598H49.3544L47.6018 0H52.1003Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M63.7611 0L61.8799 187.598H61.0971L59.4963 0H63.7611Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M75.4229 0L73.6352 187.598H72.8524L71.3918 0H75.4229Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M87.0945 0L85.3886 187.598H84.6058L83.2971 0H87.0945Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M98.7563 0L97.1439 187.598H96.3611L95.1926 0H98.7563Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M110.417 0L108.887 187.598H108.115L107.087 0H110.417Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M122.078 0L120.641 187.598H119.869L118.993 0H122.078Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M133.739 0L132.395 187.598H131.624L130.888 0H133.739Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M145.4 0L144.15 187.598H143.378L142.794 0H145.4Z"
        fill="#FF6F00"
      />
      <motion.path
        variants={svgPathVariants}
        d="M135.935 279L137.547 91.4023H138.33L139.499 279H135.935Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M124.274 279L125.804 91.4023H126.575L127.604 279H124.274Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M112.614 279L114.051 91.4023H114.822L115.698 279H112.614Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M100.952 279L102.296 91.4023H103.067L103.803 279H100.952Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M89.2915 279L90.5417 91.4023H91.3129L91.8971 279H89.2915Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M77.6184 279L78.7868 91.4023H79.5697L80.002 279H77.6184Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M65.9583 279L67.0332 91.4023H67.8161L68.1082 279H65.9583Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M54.2971 279L55.2786 91.4023H56.0614L56.2017 279H54.2971Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M43.5242 91.4023H44.3071V279H42.6362L43.5242 91.4023Z"
        fill="#15B1CD"
      />
    </motion.g>
  </motion.svg>
);

